export default {
      id: "i-service-dividents-usage",
      viewBox: "0 0 160 144",
      url: __webpack_public_path__ + "img/sprite.svg#i-service-dividents",
      toString: function () {
        return this.url;
      }
    }